import { Alert } from "@mui/material"
import { useDashboardId } from "../context/dashboard-id"
import { useDashboardLoadFailed } from "../hooks/use-dashboard-load-failed"

export default function DashboardLoadFailureNotice() {
  const dashboardId = useDashboardId()
  const loadFailed = useDashboardLoadFailed(dashboardId)

  if (!loadFailed) return null

  return (
    <Alert severity="warning" square data-testid="dashboard-load-failure-notice">
      This dashboard didn&apos;t load, so changes won&apos;t be saved. Reload to try again.
    </Alert>
  )
}
